import { ChangeDetectorRef } from '@angular/core';
import { TemporalState } from 'app/modules/main/helper/temporal-state';

export class TemporalFlag extends TemporalState<boolean> {

  constructor(
    leaveDelayInMs: number,
    enterDelayInMs: number = 0,
    initialState: boolean = false,
    changeDetector?: ChangeDetectorRef,
  ) {
    super(
      leaveDelayInMs,
      enterDelayInMs,
      false,
      true,
      initialState,
      changeDetector,
    );
  }

}
